import { IKeywordValueLabel, valueLabelPair } from "@/types/SPTypes.tsx";
import { DISPATCH_TYPE, RADIO_OPTIONS } from "../utils/enums.js";
import { FormActionTypes } from "@/actionTypes/formActionTypes.ts";

interface FormState {
  clientType: valueLabelPair<number> | null;
  questionType: valueLabelPair<number> | null;
  section: valueLabelPair<number> | null;
  keyword: IKeywordValueLabel | null;
  searchText: string;
  selectedRadioOption: string;
  showConnectedSections: boolean;
}

const initialState: FormState = {
  clientType: null,
  section: null,
  questionType: null,
  keyword: null,
  searchText: "",
  selectedRadioOption: RADIO_OPTIONS.ALL,
  showConnectedSections: false
};

const formReducer = (
  state = initialState,
  action: FormActionTypes
): FormState => {
  switch (action.type) {
    case DISPATCH_TYPE.SET_FORM_STATE:
      return { ...state, ...action.payload };
    case DISPATCH_TYPE.CLEAR_FORM_STATE:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default formReducer;
